import { isMultileg, MarketTypeEnum, useMarketAccountsContext, useMarketsContext, type Security } from '@talos/kyoko';
import { useCallback } from 'react';
import { useStrategies } from '../../providers';
import { useOrderEntry, useTradingSettings } from '../../providers/AppConfigProvider';
import { STRATEGY_GROUP } from '../../tokens/order';
import { OrderStrategiesEnum } from '../../tokens/orderStrategy';

export function useGetOrderStrategy(security: Security | undefined) {
  const { defaultOrderStrategy, defaultMultilegOrderStrategy } = useTradingSettings();
  const { lastStrategyUsed } = useOrderEntry();
  const { strategiesList: strategies } = useStrategies();
  const { marketAccountsByName } = useMarketAccountsContext();
  const { marketsByName } = useMarketsContext();

  const defaultOrderStrategyToUse = isMultileg(security) ? defaultMultilegOrderStrategy : defaultOrderStrategy;

  const getOrderStrategy = useCallback(
    (selectedMarketAccounts?: string[]) => {
      let strategy;
      let hasDarkMarket = false;
      selectedMarketAccounts?.forEach(selectedMarketAccount => {
        const ma = marketAccountsByName.get(selectedMarketAccount);
        const m = marketsByName.get(ma?.Market ?? '');
        if (m?.Type === MarketTypeEnum.Dark) {
          hasDarkMarket = true;
          strategy = strategies.find(st => st.Group === STRATEGY_GROUP.DARK)?.Name;
          return;
        }
      });
      const result = (strategy ||
        defaultOrderStrategyToUse ||
        lastStrategyUsed ||
        strategies[0]?.Name) as OrderStrategiesEnum;
      // if market is not Dark but strategy group is Dark then default to Limit strategy
      if (result && !hasDarkMarket && strategies.find(st => st.Name === result && st.Group === STRATEGY_GROUP.DARK)) {
        return OrderStrategiesEnum.Limit;
      }
      return result;
    },
    [defaultOrderStrategyToUse, lastStrategyUsed, strategies, marketAccountsByName, marketsByName]
  );

  return {
    getOrderStrategy,
  };
}
